import { Component, OnInit } from '@angular/core';
import { CursoUsuarioService } from 'src/app/servicios/curso-usuario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CursoService } from 'src/app/servicios/curso.service';

@Component({
  selector: 'app-woya',
  templateUrl: './woya.component.html',
  styleUrls: ['./woya.component.scss']
})
export class WoyaComponent implements OnInit {

  public usuarioActual;
  public yaTieneCurso = false;
  public ruta;
  constructor(public cuSvc:CursoUsuarioService, public route:ActivatedRoute, public router:Router,
              private cursoSvc:CursoService
              ) { }

  ngOnInit(): void {

    let id = this.route.snapshot.params.id;
    this.ruta = "/curso/"+id;
    console.log(this.route.snapshot.params);
    let secreto = this.route.snapshot.params.secreto;
    /************************************ 
     * ACORDATE DE CAMBIAR LAS CLAVES EN LOS BOTONES DE MERCADOPAGO BOBOOOO
     ************************************/
    //creo claves secretas para cada curso
    let git = "aaaa";
    let angular2 = "bbbb";
    let angular1 = "cccc";
    let html = "dddd";
    let c = "eeee";
    let paginaHTMLyCSS = "ffff";
    
    if(id == "Coh0CMMy2nCjeesr7IS6" && secreto == git)
    {
      //dejo pasarlo
    }
    else if(id == "We1u6GjiqZepQQajEKTO" && secreto == angular1)
    {
      //dejo pasarlo
    }
    else if(id == "483usimCjKWshxQHJnfx" && secreto == angular2)
    {
      //dejo pasarlo
    }
    else if(id == "EIyQ67Gg5DdqHWnScvam" && secreto == html)
    {
      //dejo pasarlo
    }
    else if(id == "FiuiA38l3NaBPCIBN4QY" && secreto == c)
    {
      //dejo pasarlo
    }
    else if(id == "slTvSl1E9G1rtgSJCPkn" && secreto == paginaHTMLyCSS)
    {
      //dejo pasarlo
    }
    else
    {
      //NO DEJO PASARLO
    }
  
    
    this.cuSvc.userData.subscribe(res=>
      {
        this.usuarioActual = res.uid;
        
        this.cuSvc.getAllUsuarioCurso().subscribe(res=>
          {
            //console.log(res, uidUsuarioActual);
            res.forEach(element => {
              if(element.data.usuario == this.usuarioActual)
              {
                if(element.data.curso == id)
                {
                  //ya tiene el curso!
                  this.yaTieneCurso = true;
                }
              }
            });
             
          })
        
      })//fin del suscribe

     
    

      setTimeout(() => 
    {      
       //si ledoycurso
       if(this.yaTieneCurso == false)
       {
         this.cuSvc.guardarUsuarioCurso(id);
       }
       else
       {
         //console.log("no le di nada hehehehe");
         //this.router.navigate(["/"])
       }
    },
    1500); 

  }//fin oninit

  redirigir()
  {
    this.router.navigate([this.ruta]);
  }

}
